import { IconBrandLinkedin as BrandLinkedin } from "@tabler/icons-react";
import { LOGO_URL } from "../../constants/assets";

export function Footer({ t }) {
  const footerColumns = [
    {
      title: t.footer.product,
      items: [
        // { label: t.footer.links.features, href: "#advantages" },
        { label: t.footer.links.pricing, href: "/pricing" },
        { label: t.footer.links.app, href: "https://app.innospeq.com" },
      ],
    },
    {
      title: t.footer.company,
      items: [
        { label: t.footer.links.about, href: "/about" },
        {
          label: t.footer.links.linkedin,
          href: "https://www.linkedin.com/company/innospeq",
          icon: BrandLinkedin,
        },
        // { label: t.footer.links.careers, href: "mailto:info@innospeq.com?subject=Careers%20at%20Innospeq" },
      ],
    },
    {
      title: t.footer.legal,
      items: [
        { label: t.footer.links.disclaimer, href: "/disclaimer" },
        { label: t.footer.links.privacy, href: "/privacy" },
        { label: t.footer.links.imprint, href: "/imprint" },
        // { label: t.footer.links.terms, href: "/terms" },
      ],
    },
  ];

  return (
    <footer className="border-t border-[hsl(var(--border))] bg-[hsl(var(--surface))]">
      <div className="container-x py-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <img
              src={LOGO_URL}
              alt="Innospeq"
              className="h-9 w-auto"
              style={{ filter: "var(--logo-filter, none)" }}
            />
            <p className="mt-6 max-w-sm text-sm text-muted-foreground leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerColumns.map((column) => (
              <FooterColumn key={column.title} title={column.title} items={column.items} />
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-3 border-t border-[hsl(var(--border))] pt-6 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Innospeq. {t.footer.rights}</span>
          <span className="font-mono">made with care · DE</span>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, items }) {
  return (
    <div>
      <div className="mb-4 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
        {title}
      </div>
      <ul className="space-y-2.5">
        {items.map((it, i) => {
          const isExternal = /^https?:\/\//.test(it.href);
          const Icon = it.icon;

          return (
            <li key={i}>
              <a
                href={it.href}
                className="inline-flex items-center gap-2 text-sm hover:text-brand transition-colors"
                target={isExternal ? "_blank" : undefined}
                rel={isExternal ? "noreferrer" : undefined}
              >
                {Icon ? <Icon className="h-4 w-4" /> : null}
                {it.label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
